// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__Om0t8","pulse":"styles_pulse__PgavR","jump":"styles_jump__d2W5G"};